import * as React from "react";
import { HeadingTypeTwo, Icon } from "sb-resp-lib";

export class Heading extends React.Component<{ label: string }, {}> {
    render() {
        return (
            <HeadingTypeTwo modifier="my-pulse-bets">
                <span className="rj-heading-2__left-container">
                    <Icon i="i-24 i-o-pulsebet-pulse" />
                </span>

                <span className="rj-heading-2__text-container">
                    <span className="rj-heading-2__text">{this.props.label}</span>
                </span>
            </HeadingTypeTwo>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./components/Heading/Heading.tsx